export const FileManagerPageHeader = () => {
    return (
        <div>
            <ol className="breadcrumb float-xl-end">
                <li className="breadcrumb-item"><a href="#/">Home</a></li>
                <li className="breadcrumb-item"><a href="#/">Files</a></li>
                <li className="breadcrumb-item active">File Manager</li>
            </ol>
            <h1 className="page-header">File Manager <small>manage your organisation's files</small></h1>
        </div>
    );
};